import { render, staticRenderFns } from "./customer-detail.vue?vue&type=template&id=0f2c6fb6&scoped=true&"
import script from "./customer-detail.vue?vue&type=script&lang=js&"
export * from "./customer-detail.vue?vue&type=script&lang=js&"
import style0 from "./customer-detail.vue?vue&type=style&index=0&id=0f2c6fb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2c6fb6",
  null
  
)

export default component.exports